import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const HeroTitle = ({ activeIndex }) => {
  const serviceHeroTitles = [
    "Website\nE-Commerce",
    "WordPress\nHeadless CMS",
    "Website Maintenance\n& Support",
    "SEO & GEO\nOptimization",
    "Landing\nPage",
    "Android & iOS\nApplication"
  ];

  const currentTitle = serviceHeroTitles[activeIndex] || "";

  return (
    <div className="tp-hero-title">
      <AnimatePresence mode="wait">
        <motion.h2
          key={activeIndex}
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -15 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
        >
          {currentTitle.split('\n').map((line, i) => (
            <span key={i} style={{ display: "block" }}>
              {line}
            </span>
          ))}
        </motion.h2>
      </AnimatePresence>
    </div>
  );
};

export default HeroTitle;
